import React from 'react';
import { useHistory } from 'react-router-dom'

const FeaturedItems = ({items}) => {
    const history = useHistory()


    const renderItems = (items) => items.map((item, i) => (
        <div className="playlist__item" key={i} onClick={(e) => history.push(`/playlist/${item.id}`)}>
            <div className="playlist__image">
                <img src={`${item.images[0].url}`} />
            </div>
            <h4>{item.name}</h4>
            {/* <p>By Jazz B</p> */}
        </div>
    )) 

    return (
        <div className="featured__items">
            {renderItems(items)}
        </div>
    );
}

export default FeaturedItems;
